<like [likes]="likes" [dislikes]="dislikes" [contentId]="contentId"></like>